import { Grid, CardActions } from "@mui/material";
import styled from "styled-components";
import { keyframes } from "styled-components";

export const MessageBox = styled(Grid)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  direction: rtl;

  @media (max-width: 700px) {
    display: block !important;
  }
`;

export const DeleteIconMessage = styled(CardActions)`
  width: 40px;
  height: 40px;
  color: red;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  padding: 0px;
  cursor: pointer;
  &:hover {
    box-shadow: inset 0px 0px 5px rgba(0, 0, 0, 0.3);
  }

  @media (max-width: 600px) {
    width: 25px;
    height: 25px;
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
`;

const MessageSeenAnimation = keyframes`
  0% { background-color: green; }
  20% { background-color: green; }
  80% { background-color: red; }
 100% { background-color: red; }
`;

export const MessageSeen = styled.span`
  width: 20px;
  height: 20px;
  background-color: green;
  border-radius: 100%;
  display: inline-block;
  animation-name: ${MessageSeenAnimation};
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
`;
